
















import Vue from 'vue'
import Container from '../Container/Container.vue'
import Layout from '../Layout/Layout.vue'
import BaseCard from '../BaseCard.vue'

export default Vue.extend({
  name: 'PageCard',
  components: { Layout, Container, BaseCard },
  props:{
    listContainer: Boolean
  }
})
